import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {ReceivablesImportRow} from "../../../../shared/interface/receivables-import-row";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../../shared/services/auth.service";
import {FilterService} from "../../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, first, takeUntil} from "rxjs/operators";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {HttpErrorResponse} from "@angular/common/http";
import {ReceivablesImportsRowService} from "../../../../shared/services/receivables-imports-row.service";
import {getCurrentRouteState} from "../../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../../shared/ngrx/route-serializer";
import {Sort} from "@angular/material/sort";
import {InsuranceCompany} from "../../../../shared/interface/insurance-company";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../../shared/components/job-result-dialog/job-result-dialog.component";
import {
  RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED,
  RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION, RECEIVABLES_IMPORT_ROW_STATUS_PAID
} from "../../../../shared/services/dict.service";

@Component({
  selector: 'app-all-receivables-imports-row-list',
  templateUrl: './all-receivables-imports-row-list.component.html',
  styleUrls: ['./all-receivables-imports-row-list.component.scss']
})
export class AllReceivablesImportsRowListComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() statusKey?: string[] = null;
  @Input() partnerId?: string =  null;
  @Input() receivablesBalanceId?: string =  null;
  @Input() showFilter = true;
  @Input() embeddedView = false;

  initialFilters: any;
  rows: ReceivablesImportRow[] = [];
  displayedColumns: string[] = [
    'policyNumber', 'amount', 'paymentAt', 'changeToPaidAt', 'createdAt', 'insuranceCompany', 'partner', 'ofwca', 'company', 'status'
  ];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  sortBy = 'createdAt';
  sortOrder = 'desc';
  selectedInsuranceCompanies: InsuranceCompany[] = [];
  serviceKey = '';

  readonly RECEIVABLES_IMPORT_ROW_STATUS_PAID = RECEIVABLES_IMPORT_ROW_STATUS_PAID;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
    private receivablesImportsRowService: ReceivablesImportsRowService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.receivablesImportsRowService.rowListSubject
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      ).subscribe({
      next: (response: CountedAndPaginated<ReceivablesImportRow>) => {
        this.rows = response.items;
        this.totalData = response.pagination.total;
      },
      error: (response: HttpErrorResponse) => {
        this.snack.open('Przy ładowaniu danych wystąpił błąd', response.status.toString(), {duration: 2000});
      }
    });
    this.parseFilters();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      in$insuranceCompany: 'int[]',
      importer: 'int[]',
      company: 'int',
      partner: 'string',
      partnerAssetsRegional: 'string',
      ofwca: 'string',
      containsFromLeft$policyNumber: 'string',
      gte$amountDue: 'string',
      lte$amountDue: 'string',
      gte$paymentDate: 'string',
      lte$paymentDate: 'string',
      gte$conclusionAt: 'string',
      lte$conclusionAt: 'string',
      in$status: 'int[]',
      contains$customerName: 'string',
      rauNumber: 'string',
      contains$ofwcaIdNumber: 'string',
      contractNumber: 'string',
      haveBalance: 'int',
      fileName: 'string',
    }, filters);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        this.statusKey = this.statusKey ?? data.statusKey ?? null;
        if (this.statusKey) {
           if (this.statusKey.includes(RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED)) {
             this.serviceKey = '-canceled';
           }
        }
        if (!this.embeddedView) {
          this.store
            .pipe(
              select(getCurrentRouteState),
              delay(0),
              distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
              takeUntil(this.destroyed$),
            )
            .subscribe((state: RouterStateUrl) => {
              this.parseFilters(state.params);
              this.paginator.pageIndex = state.params.page;
              this.paginator.pageSize = state.params.pageSize;
              this.loadListData();
            });
        } else {
          this.loadListData();
        }
      });
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      if (this.embeddedView) {
        this.loadListData();
      } else {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: event.pageIndex,
          pageSize: event.pageSize,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          ...this.filtersForm.value
        })]);
      }
    });
  }

  sortChanged($event: Sort): void {
    this.sortBy = $event.active;
    this.sortOrder = $event.direction;

    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      sortBy: $event.active,
      sortOrder: $event.direction,
      page: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value
    })]);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    if (null !== this.statusKey) {
      filters.statusKey = this.statusKey;
    }

    if (null !== this.partnerId) {
      filters.partner = this.partnerId;
    }

    if (null !== this.receivablesBalanceId) {
      filters.receivablesBalance = this.receivablesBalanceId;
    }


    return filters;
  }

  async loadListData(): Promise<void> {
    this.receivablesImportsRowService.loadList(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.buildFilters(),
      this.serviceKey,
      {
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      });
  }

  filter(): void {
    if (this.embeddedView) {
      if (this.paginator.pageIndex === 0) {
        this.loadListData();
      } else {
        this.paginator.firstPage();
      }
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: 0,
        pageSize: this.paginator.pageSize,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
        ...this.filtersForm.value,
      })]);
    }
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    if (this.embeddedView) {
      this.loadListData();
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
        page: 0,
        pageSize: this.paginator.pageSize,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
      }]);
    }
  }

  downloadReport(): void {
    this.receivablesImportsRowService.downloadReport(this.buildFilters(), this.serviceKey)
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

}
